import axios, { AxiosInstance } from 'axios'
import { BaseUrls } from './base-urls'
import store from '../redux/store'
import { userManager } from './services/oidc.service'
import { setVerified } from '../redux/reducer/commonSlice'
import { closeDialog } from '../redux/reducer/dialogSlice'

let ClientsAxios: any = {}

Object.keys(BaseUrls).forEach((base: any) => {    
    ClientsAxios[base] = axios.create({ baseURL: BaseUrls[base].url })
    console.log("base55555555555",base,base.includes("GUEST"))
    if(base.includes("GUEST")){        
        addGuestInterceptor(ClientsAxios[base], BaseUrls[base].config,  store.dispatch)
    }        
    else {addInterceptor(ClientsAxios[base], BaseUrls[base].config)}
})

function addInterceptor(instance: AxiosInstance, requestExtetion: any): AxiosInstance {
    instance.interceptors.request.use(async (request) => {
        const authUser = store.getState().authUser
        if (authUser && authUser.token) request.headers['Authorization'] = authUser.token
        request.headers['Accept'] = 'Application/json'
        request.headers['Content-Type'] = 'application/octet-stream'
        return request
    }, (error) => {
        return Promise.reject(error)
    })

    instance.interceptors.response.use((response) => {
        return response
    },  (error) => {
        if (error && error.response.status === 401) {
            // try {
            //     await userManager.clearStaleState(); // Clean up stale OIDC state
            // } catch (e) {
            //     console.error("Failed to clear stale OIDC state:", e);
            // }
             window.open("/auth/login", "_self")
        } else {
            // store.dispatch(showSnackbar({ open: true, type: 'error', message: error.response.data.message ? error.response.data.message : 'Something went wrong' }))
            return Promise.reject(error);
        }
    })
    return instance
}

function addGuestInterceptor(instance: AxiosInstance, requestExtetion: any,dispatch: any): AxiosInstance {
    instance.interceptors.request.use(async (request) => {
        // const authUser = store.getState().authUser
        // if (authUser && authUser.token) request.headers['Authorization'] = authUser.token
        request.headers['Accept'] = 'Application/json'
        request.headers['Content-Type'] = 'application/octet-stream'
        return request
    }, (error) => {
        return Promise.reject(error)
    })

    instance.interceptors.response.use((response) => {
        return response
    },  (error) => {
        if (error && error.response.status === 401) {
            dispatch(setVerified(false));
            dispatch(closeDialog());
            sessionStorage.setItem("verify-token", "");

        } else {
            // store.dispatch(showSnackbar({ open: true, type: 'error', message: error.response.data.message ? error.response.data.message : 'Something went wrong' }))
            return Promise.reject(error);
        }
    })
    return instance
}
export default ClientsAxios